import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    pluralizationRules: {
        ru(choice, choicesLength) {
            if (choice === 0) {
                return 0;
            }
            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
                return !teen && endsWithOne ? 1 : 2;
            }
            if (!teen && endsWithOne) {
                return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2;
            }

            return choicesLength < 4 ? 2 : 3;
        },
    },
    locale: 'ru',
    messages: {
        ru: {
            dishes: 'блюд | блюдо | блюда | блюд',
            position: 'позиций | позиция | позиции | позиций',
            variants: 'вариантов | вариант | варианта | вариантов',
            people: 'человек | человек | человека | человек',
            books: 'книг | книга | книги | книг',
            seconds: 'секунд | секунда | секунды | секунд',
            secondsTo: 'секунд | секунду | секунды | секунд',
            views: 'просмотров | просмотр | просмотра | просмотров',
        },
    },
    numberFormats: {
        ru: {
            currency: {
                style: 'currency',
                currency: 'RUB',
                notation: 'standard',
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            percent: {
                style: 'percent',
                useGrouping: false,
            },
        },
    },
    datetimeFormats: {
        ru: {
            short: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            },
            normal: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            },
            day: {
                day: 'numeric',
            },
            weekday: {
                weekday: 'long',
            },
            weekday_short: {
                weekday: 'short',
            },
            day_month: {
                day: 'numeric',
                month: 'long',
            },
            month: {
                month: 'long',
            },
            time: {
                hour: 'numeric',
                minute: 'numeric',
            },
        },
    },
});

export default i18n;
